import { render, staticRenderFns } from "./confirmMatch.vue?vue&type=template&id=0e50b018&scoped=true"
import script from "./confirmMatch.vue?vue&type=script&lang=js"
export * from "./confirmMatch.vue?vue&type=script&lang=js"
import style0 from "./confirmMatch.vue?vue&type=style&index=0&id=0e50b018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e50b018",
  null
  
)

export default component.exports